import {injectable, inject} from "inversify";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import type {IHttpClientService, IApiResponse} from "data/services/http";
import {ContextualProjects} from "data/enums";

export interface ISuccessPrompt {
	prompt: IPrompt | null;
}

export interface IPrompt {
	game: ContextualProjects;
	message: IMessage;
}

export interface IMessage {
	en: string;
	es: string;
}

export interface IContextualPromptBannerProvider {
	check: (uid: string) => Promise<AxiosResponse<IApiResponse<ISuccessPrompt>>>;
	user_decline: (uid: string) => Promise<AxiosResponse<IApiResponse>>;
}

@injectable()
export class ContextualPromptBannerProvider implements IContextualPromptBannerProvider {
	constructor(@inject(Bindings.GlobalApiHTTPClient) private _http: IHttpClientService) {}

	check = (uid: string) =>
		this._http.get<IApiResponse<ISuccessPrompt>>(
			`global/prompt/${uid}/${ContextualProjects.SPINBALL}`
		);
	user_decline = (uid: string) =>
		this._http.post<IApiResponse>(`global/user_decline/${uid}/${ContextualProjects.SPINBALL}`);
}
